jQuery(function($){
  function stickyHeader() {
    if ($(window).scrollTop() > 100) {
      $('.header').addClass('is-sticky');
    } else {
      $('.header').removeClass('is-sticky');
    }
  }
  
    $("#nav-icon1").off("click").on("click", function () {
      $(this).toggleClass("open");
      $(".main-menu-wrap").toggleClass("open");
    });

    $(".md-search").off("click").on("click", function () {
      $(this).toggleClass("open");
      $(".header-search").toggleClass("open");
    });

    // $('.main-section').attr('style', 'padding-top: ' + ($('.header').height() - 15) + 'px' );

    stickyHeader();
    
    $(window).on('scroll', function() {
        stickyHeader();
         $(".header-search,.md-search").removeClass("open");
         $(".main-menu-wrap,#nav-icon1").removeClass("open");
          setTimeout(function(){
            initFooterAccordion();
          }, 500);
    });
  

    function initFooterAccordion() {
    if ($(window).width() <= 768) {
      $('.footer-title').off('click').on('click', function() {
        $(this).parent('.footer-column').toggleClass('active')
          .siblings().removeClass('active');
      });
    } else {
      $('.footer-title').off('click');
      $('.footer-column').removeClass('active');
    }
    let $header_height = $('.header').height() - 15;
    console.log($header_height);
    $('.main-section').attr('style', 'padding-top: ' + ($header_height) + 'px' );
  }

  initFooterAccordion();
  $(window).on('load resize', function(){
    setTimeout(function(){
      initFooterAccordion();
    }, 500); 
    
});


$('.offer-slider').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  centerMode: true,
  adaptiveHeight: false,
  variableWidth: true,
  infinite: true,
  dots: false,
  arrows:true,
  responsive: [
    {
      breakpoint: 1024, // Tablet
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 600, // Mobile
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480, // Small Mobile
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});




});
